import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 19 20" ref={ref} {...props}><path stroke="#4A4A4A" d="M5 0v4M14 0v4" /><rect width={18} height={17} x={0.5} y={2.5} stroke="#4A4A4A" rx={1.5} /><path stroke="#4A4A4A" d="M0 7.5h18.095" /></svg>;
const ForwardRef = forwardRef(SvgCalendar);
export default ForwardRef;